import React from "react";
import NewslettersContainer from "../../containers/newsletter/index";
import NewsletterContainer from "../../containers/newsletter/Newsletter";
import { useParams } from "react-router-dom";

const NewslettersPage = () => {
  let { id } = useParams();

  return id ? <NewsletterContainer id={id} /> : <NewslettersContainer />;
};

export default NewslettersPage;
